export const unassignedSalesLeadsPrecalculations = 'unassignedSalesLeads';
export const unassignedRiskAppPrecalculations = 'unassignedRiskApp';
export const conditionallyApprovedBoardedAppPrecalculations = 'conditionallyApprovedBoardedApp';
export const agentSupportUnassignedAppPrecalculations = 'agentSupportUnassignedApp';
export const underwritingUnassignedAppPrecalculations = 'underwritingUnassignedApp';
export const unassignedErpTicketPrecalculations = 'unassignedErpTicket';
export const getUnassignedUserTicketPrecalculationsName = (userId: string | undefined) => {
  return userId ? `unassignedUser_${userId}_Ticket` : undefined;
};
